import React, { FC, useMemo } from 'react';

import { EvSection } from '@evinced-private/ui-common';

import { FrequencyDto, JobTypeDto } from '../../interfaces/ScheduledJobConfiguration';

import { SchedulingSectionContextWrapper } from './context/SchedulingSectionContextWrapper';
import { SchedulingSectionProps } from './SchedulingSection.types';
import { SectionHeader } from './SectionHeader';
import { SectionMainBlockWithContext } from './SectionMainBlockWithContext';

import './SchedulingSection.scss';

export const SchedulingSection: FC<SchedulingSectionProps> = (props) => {
	const { initialConfig, onConfigChange, error } = props;

	const { active, frequency, interval, jobType, ...rest } = initialConfig || {};

	const configWithDefaults = useMemo(() => {
		return {
			active: active || false,
			frequency: frequency || FrequencyDto.WEEKLY,
			interval: interval || 1,
			jobType: jobType || JobTypeDto.CRAWL,
			...rest
		};
	}, [active, frequency, interval, jobType, rest]);

	return (
		<EvSection>
			<div className="scheduling-section-wrapper">
				<fieldset
					className="scheduling-section-fieldset"
					aria-labelledby="scheduling-section-title"
				>
					<SchedulingSectionContextWrapper
						initialConfig={configWithDefaults}
						onConfigChange={onConfigChange}
						error={error}
					>
						<SectionHeader />
						<SectionMainBlockWithContext />
					</SchedulingSectionContextWrapper>
				</fieldset>
			</div>
		</EvSection>
	);
};
